import { useState } from 'react'
import { Link } from 'react-router-dom'
import { api, qs } from '../../lib/api.js'
import { Badge, Card, Empty, ErrorBox, Page, Spinner, useAsync } from '../../components/Ui.jsx'
import { fmtDate, fmtStamp, lakh } from '../../lib/format.js'

const TRIP_TONE = { assigned: 'info', packing: 'info', in_transit: 'warn', delivered: 'good', issue: 'bad' }

export default function Trips () {
  const [status, setStatus] = useState('open')
  const { data, error, loading, reload } = useAsync(() => api.get(`/operator/trips${qs({ status })}`), [status], { live: ['trips', 'orders'] })
  const trips = data?.trips || []

  return (
    <Page
      title="Logistics control"
      subtitle="Third-party pickups, each escorted by a platform liaison officer from the hatchery gate to the pond."
    >
      <Card padded={false}>
        <div className="filterbar">
          <div className="chips">
            {[['open', 'On the road'], ['delivered', 'Delivered'], ['', 'All trips']].map(([v, label]) => (
              <button key={label} className={`chip ${status === v ? 'on' : ''}`} onClick={() => setStatus(v)}>{label}</button>
            ))}
          </div>
          <div style={{ flex: 1 }} />
          <div className="muted small">{trips.length} trip(s)</div>
        </div>

        {loading
          ? <Spinner />
          : error
            ? <div className="body"><ErrorBox error={error} onRetry={reload} /></div>
            : (
              <div className="scroll-x">
                <table>
                  <thead>
                    <tr>
                      <th>Trip</th><th>Route</th><th>Vehicle & driver</th><th>Liaison</th>
                      <th className="num">Load</th><th>Packed</th><th>Delivered</th><th>Status</th><th />
                    </tr>
                  </thead>
                  <tbody>
                    {trips.map(t => (
                      <tr key={t._id}>
                        <td>
                          <span className="mono">{t.tripCode}</span>
                          <span className="t-sub">
                            <Link to={`/operator/orders/${t.order?._id}`}>{t.order?.orderCode}</Link>
                          </span>
                        </td>
                        <td>
                          {t.order?.hatchery?.name} → {t.order?.farmer?.village || t.order?.farmer?.name}
                          <span className="t-sub">{t.distanceKm} km · ~{t.estHours} hrs · stocking {fmtDate(t.order?.targetStockingDate)}</span>
                        </td>
                        <td className="mono small">{t.vehicle?.regNo}<span className="t-sub">{t.vehicle?.driverName} · {t.vehicle?.driverPhone}</span></td>
                        <td>{t.liaison?.name}<span className="t-sub">{t.liaison?.phone}</span></td>
                        <td className="num">
                          {t.bagsLoaded ?? '—'}
                          <span className="t-sub">{lakh(t.order?.quantityLakh)}</span>
                        </td>
                        <td className="small">{t.packedAt ? fmtStamp(t.packedAt) : '—'}</td>
                        <td className="small">
                          {t.deliveredAt ? fmtStamp(t.deliveredAt) : '—'}
                          {t.damagedBags > 0 && <span className="t-sub" style={{ color: 'var(--bad)' }}>{t.damagedBags} bag(s) damaged</span>}
                        </td>
                        <td>
                          <Badge tone={TRIP_TONE[t.status] || 'muted'}>{t.status.replace(/_/g, ' ')}</Badge>
                          {t.issueNote && <span className="t-sub" style={{ color: 'var(--bad)' }}>{t.issueNote}</span>}
                        </td>
                        <td className="right"><Link className="btn sm" to={`/liaison/trips/${t._id}`}>Field view</Link></td>
                      </tr>
                    ))}
                    {!trips.length && <tr><td colSpan={9}><Empty>No trips in this view.</Empty></td></tr>}
                  </tbody>
                </table>
              </div>
              )}
      </Card>
    </Page>
  )
}
